<script>
  import RowCard from "../molecules/rowCard.vue";

  export default {
    name: "DropDownOrganism",
    components: { RowCard },
    props: {
      list: Array,
      itemId: String,
      currentItem: Object,
      placeholder: String,
      disabled: Boolean,
      value: Array,
    },
    data() {
      return {
        search: "",
        open: false,
        listItems: [],
      };
    },
    computed: {
      filteredItems() {
        const q = this.search.toLowerCase();
        const filter = this.list.filter((u) => !this.listItems.find((s) => s._id === u._id) && u.user.toLowerCase().includes(q));

        const index = filter.findIndex((item) => this.currentItem?.monitorId === item._id);
        if (index !== -1) {
          const [fixedItem] = filter.splice(index, 1);
          return [fixedItem, ...filter];
        }
        return filter;
      },
      monitorFixed() {
        return (item) => (this.currentItem?.monitorId === item._id ? "Monitor Fijo" : "");
      },
      showDeleteAll() {
        return this.listItems.length === 4;
      },
    },
    methods: {
      addItem(item) {
        if (this.listItems.length === 4) return;

        const isDuplicate = this.listItems.find((u) => u._id === item._id);
        if (isDuplicate) return;

        this.listItems.push(item);
        this.$emit("input", this.listItems, this.itemId);
        this.search = "";
      },
      removeItem(item) {
        const index = this.listItems.findIndex((u) => u._id === item._id);
        if (index !== -1) this.listItems.splice(index, 1);
        this.$emit("input", this.listItems, this.itemId);
      },
      removeAllItems() {
        this.listItems = [];
        this.$emit("input", [], this.itemId);
      },
      handleBlur() {
        setTimeout(() => {
          this.open = false;
        }, 150);
      },
      truncate(str, max = 17) {
        return str.length > max ? str.slice(0, max) + "…" : str;
      },
      getNameResponsive(name) {
        if (this.listItems.length < 3) return name;
        return this.truncate(name);
      },

      setListItems(value) {
        this.listItems = value;
      },
    },
    watch: {
      value: {
        handler(val) {
          this.setListItems(val);
        },
        immediate: true,
      },
    },
    mounted() {
      this.setListItems(this.value);
    },
  };
</script>

<template>
  <div class="DropDownOrganism">
    <div :class="`DropDownOrganism__selected ${open ? 'DropDownOrganism__selected--open' : ''}`">
      <div class="DropDownOrganism__chip">
        <RowCard
          v-for="(item, index) in listItems"
          :key="index"
          :item="item"
          :title="index === 0 ? getNameResponsive(item.user) : ''"
          :img="item.picture"
          :tooltipText="item.user"
          :showIcon="true"
          :canShowTooltip="index !== 0"
          :showBackground="true"
          colorHover="#DFDFDF"
          @onClick="removeItem(item)" />
        <RowCard
          class="DropDownOrganism__deleteAll"
          v-if="showDeleteAll"
          :title="currentItem?.user"
          title=""
          :subTitle="monitorFixed(currentItem)"
          :showIcon="true"
          :styleImg="{ border: 'none', width: '26px', height: '26px' }"
          img="closeIcon"
          :useIconic="true"
          :showBackground="false"
          @onClick="removeAllItems()" />
      </div>
      <input
        v-if="listItems.length < 4"
        type="text"
        v-model="search"
        @focus="open = true"
        @blur="handleBlur"
        class="DropDownOrganism__input"
        :placeholder="listItems.length ? '' : placeholder"
        :disabled="disabled" />
    </div>
    <div class="DropDownOrganism__listOuter" v-if="open && filteredItems.length">
      <div ref="dropdownList" class="DropDownOrganism__list">
        <RowCard
          v-for="(item, index) in filteredItems"
          :key="index"
          :item="item"
          :title="item.user"
          :subTitle="monitorFixed(item)"
          variant="nonBorderRadius"
          colorHover="#e9e9e9"
          :img="item.picture"
          @onClick="addItem" />
      </div>
    </div>
  </div>
</template>

<style lang="scss">
  .DropDownOrganism {
    position: relative;
    width: 350px;
    background: #fff;
    &__selected {
      @include Flex(row, flex-start, center);
      gap: 6px;
      padding: 8px 12px;
      border: 1px solid #e3e3e3;
      border-radius: 8px;
      &--open {
        border: 1px solid #adadad;
      }
    }
    &__chip {
      display: flex;
      gap: 4px;

      .rowCard {
        gap: 0;
      }

      &:first-child {
        .rowCard {
          gap: 6px;
        }
      }
    }
    &__input {
      width: 100%;
      flex: 1;
      border: none;
      outline: none;
      padding: 4px;
      background: #fff;
    }
    &__listOuter {
      position: absolute;
      width: 100%;
      top: 100%;
      background: white;
      left: 0;
      z-index: 10;
      box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
      border: 1px solid #e9e9e9;
      padding: 8px 8px 8px 0px;
      border-radius: 8px;
    }
    &__list {
      width: 100%;
      height: 180px;
      overflow-y: auto;
      background: white;
      &::-webkit-scrollbar {
        width: 6px;
        background-color: #ccc;
        border-radius: 8px;
      }
      &::-webkit-scrollbar-thumb {
        background-color: #a8a9a9;
        border-radius: 8px;
      }
    }
    &__deleteAll {
      padding: 0;
      .CircleImg__img {
        font-size: 10px;
      }
    }
    &__item {
      padding: 8px;
      cursor: pointer;
      &:hover {
        background-color: #eee;
      }
    }
  }
</style>
